export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 10_05.d853ae2c.jpg";